/** L'écart entre la sortie et l'entrée d'un positionnement (#321), signé : « +2 », « 0 », « −1 ». */
export function levelGap(entry: number | undefined, exit: number | undefined): string {
  if (entry == null || exit == null) return '—'
  const gap = exit - entry
  return gap > 0 ? `+${gap}` : gap < 0 ? `−${-gap}` : '0'
}
